import { Helmet } from 'react-helmet-async'
import { Navigate } from 'react-router-dom'
import { useAdminAccess } from 'src/helpers/hooks'
import { useLocale } from 'src/hooks/locale/locale'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useUserStateMutateOnMount } from 'src/hooks/userState'
import Warning from 'src/imgs/classroom_icon.svg'
import NoContent from 'src/views/components/NoContent'

export default function AdministratorHomePage(): JSX.Element | null {
  const t = useTranslatable()
  useUserStateMutateOnMount()

  return (
    <>
      <Helmet title={t('system:home_page')} />
      <PageContent />
    </>
  )
}

export function PageContent(): JSX.Element | null {
  const t = useTranslatable()
  const { firstAccessiblePath } = useAdminAccess()
  const locale = useLocale()

  if (firstAccessiblePath != null) {
    return <Navigate replace to={`/${locale}/${firstAccessiblePath}`} />
  }
  return <NoContent image={Warning} header={t('error:not_have_permission')} />
}
